<page-content [fullPageWidth]="true">
    <header-elitment header
            [hasSideMenu]="true">
    </header-elitment>
    <side-menu left-menu>
        <test-side-menu
            [tests]="testsLeftMenu"
            [organization]="organization"
            [athleteUser]="athleteUser"
            [activeTestId]="activeTestId"
            [testsChange]="testsChange">
        </test-side-menu>
    </side-menu>
    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>

    <module-content *ngIf="!is401 && !is404" [title]="test.name ?? ''">
        <app-test-generic-container [organization]="organization" [athleteUser]="athleteUser" [test]="test" (updateSideMenuEvent)="updateSideMenuEvent(activeTestId)"></app-test-generic-container>
    </module-content>
</page-content>
